/* eslint-disable camelcase */

/**
 * Rules for filtering and replacing the unique id of a path for safely logging `screenId`.
 *
 * Each property in the `ID_PATTERNS` object must follow the following strict guidelines:
 * [KEY] must match the section of the path directly before the unique ID.
 *   e.g. given the path `.../opportunities/OPID123456789`, the KEY must be `opportunities`.
 *
 * The value of [KEY] must be an object, with 2 properties: `pattern` and `placeholder`.
 * `pattern` is a required property, however `placeholder` is optional.
 *
 * The value of `pattern` must be a RegEx which will match the format of the ID that
 * will follow [KEY] in the path.
 *   e.g. given the path `.../opportunities/OPID123456789`, the pattern could be `/^OPID/`
 *   since every opportunity ID starts with the characters `'OPID'`.
 *
 * The optional value of 'placeholder' must be a string to be used in place of the
 * id in the path. If not provided, by default `':id'` is used.
 *   e.g. given the path `.../opportunities/OPID123456789` and given the rules
 *     ````
 *       opportunities: {
 *         pattern: /^OPID/,
 *         placeholder: ':id',
 *       }
 *     ````
 *   screenId would be modified to return `'opportunities/:id'`
 */
export const ID_PATTERNS = {
  billboards: {
    // /billboard-editor/billboards/:id
    pattern: /^SABI/,
    placeholder: ':id',
  },
  history: {
    // /billing/invoices/history/:id
    pattern: /^ORID/,
    placeholder: ':id',
  },
  invoices: {
    // /billing/invoices/:id
    pattern: /^[A-Z0-9]{10}$/,
    placeholder: ':id',
  },
  opportunities: {
    // /opportunities/:id
    pattern: /^OPID/,
    placeholder: ':id',
  },
  published_billboards: {
    // /billboard-editor/published_billboards/:id
    pattern: /^SABI/,
    placeholder: ':id',
  },
};
